import React, { useMemo } from 'react';
import { bool, object, string } from 'prop-types';
import classnames from 'classnames';
import { I18n } from '@fiverr-private/i18n-react';
import { PriceUpfrontTooltip, TooltipWrapper } from '@fiverr-private/gig_listings';
import { useCalculatePriceBreakdown, BUYABLE_TYPE } from '@fiverr-private/price_upfront_sdk';
import { convertFromUSD } from '../../../utils/currencyConverter';
import './index.scss';

export const Price = ({ containerClassName, priceInUSD, currency, isHourlyPrice }) => {
    const text = isHourlyPrice ? 'listings.expert_card.footer.hourlyPrice' : 'listings.expert_card.footer.price';
    const buyableType = isHourlyPrice ? BUYABLE_TYPE.HOURLY : BUYABLE_TYPE.GIG;
    const { calculatePriceBreakdown } = useCalculatePriceBreakdown();
    const priceBreakdown = useMemo(
        () => calculatePriceBreakdown({ netPrice: Number(priceInUSD), buyableType }),
        [calculatePriceBreakdown, priceInUSD, buyableType]
    );
    const price = useMemo(
        () => convertFromUSD(priceBreakdown?.gross_price ?? priceInUSD, currency),
        [priceBreakdown?.gross_price, priceInUSD, currency]
    );

    const priceContent = (
        <div className={classnames('footer-price co-text-darker', containerClassName)}>
            <I18n
                k={text}
                params={{ price }}
                templates={{
                    priceSection: (text) => <span className="text-bold">{text}</span>,
                }}
            />
        </div>
    );

    const showTooltip = priceBreakdown?.gross_price !== priceInUSD;

    return (
        <TooltipWrapper content={<PriceUpfrontTooltip />} shouldRenderTooltip={showTooltip} position="bottom">
            {priceContent}
        </TooltipWrapper>
    );
};

Price.propTypes = {
    priceInUSD: string.isRequired,
    currency: object,
    containerClassName: string,
    isHourlyPrice: bool,
};
